import { Box, Center } from "@chakra-ui/react";
import Image from "next/image";

interface ThumbnailProps {
  ext_file?: string;
  comp_file?: string;
  image?: string;
}

const Thumbnail = (props: ThumbnailProps) => {
  return (
    <Center cursor={"pointer"}>
      <Box
        borderRadius="md"
        maxWidth={350}
        minWidth={260}
        minHeight={260}
        overflow="hidden"
      >
        <Image
          src={props.comp_file ?? props.ext_file ?? props.image ?? ""}
          alt="Thumbnail"
          height={380}
          width={380}
        />
      </Box>
    </Center>
  );
};

export default Thumbnail;
